// Keep the mobile menu usable across anchor navigation and theme-editor reloads.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.bg-mobile-menu a');
  if (link) link.closest('details').removeAttribute('open');
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.bg-mobile-menu[open]').forEach(menu => {
    menu.removeAttribute('open'); menu.querySelector('summary').focus();
  });
});

// Delegation also supports sections reloaded by Shopify's theme editor.
document.addEventListener('change', event => {
 if (!event.target.matches('[data-bg-amount]')) return;
 const amount = Number(event.target.value);
 const result = event.target.closest('[data-bg-duration]').querySelector('[data-bg-duration-result]');
 result.textContent = [0.5, 1, 1.5, 2].includes(amount)
   ? event.target.closest('[data-bg-duration]').dataset.result.replace('{days}', 30 / amount) : event.target.closest('[data-bg-duration]').dataset.empty;
});

(() => {
 const storage = {get(k){try{return localStorage.getItem(k)}catch{return null}},set(k,v){try{localStorage.setItem(k,v)}catch{}}};
 function initialize(){
  document.querySelectorAll('[data-bg-welcome]').forEach(el=>{el.hidden=!!storage.get('bg-language-welcome-dismissed') || !document.querySelector('[data-bg-language]')});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
 document.addEventListener('shopify:section:load',initialize);
 document.addEventListener('click',e=>{
  if(e.target.closest('[data-bg-dismiss]')){storage.set('bg-language-welcome-dismissed','1');document.querySelectorAll('[data-bg-welcome]').forEach(el=>el.hidden=true)}
  if(e.target.closest('[data-bg-open-language]')){
   const menu=document.querySelector('[data-bg-language]');if(menu){menu.open=true;menu.querySelector('select').focus()}
  }
  if(!e.target.closest('[data-bg-language]')&&!e.target.closest('[data-bg-open-language]'))document.querySelectorAll('[data-bg-language]').forEach(el=>el.open=false);
 });
 document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('[data-bg-language][open]').forEach(el=>{el.open=false;el.querySelector('summary').focus()})});
 document.addEventListener('submit',e=>{if(e.target.closest('[data-bg-language]')){storage.set('bg-language-welcome-dismissed','1');storage.set('bg-preferred-language',e.target.querySelector('[name="language_code"]').value)}});
})();

document.addEventListener('click',function(e){const a=e.target.closest('a[href="#story-details"]');if(a){const d=document.getElementById('story-details');if(d)d.open=true;}});
